import * as React from "react";
import { QuickJournalSystemClockEventName } from "../Data/Clock/QuickJournalClock";

export function useQuickJournalSystemClockVersion(): number {
    const [version, setVersion] = React.useState(0);

    React.useEffect(() => {
        const handleChange = () => setVersion((currentValue) => currentValue + 1);

        window.addEventListener(QuickJournalSystemClockEventName, handleChange);
        window.addEventListener("storage", handleChange);

        return () => {
            window.removeEventListener(
                QuickJournalSystemClockEventName,
                handleChange
            );
            window.removeEventListener("storage", handleChange);
        };
    }, []);

    return version;
}
